import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  PlaceholderText,
  QueryFieldButton,
  QueryFieldText,
} from './MobileSearchQueryField.styled';

type Props = {
  query?: string;
  location?: string;
  onClick: () => void;
};

export function MobileSearchQueryField({ query, location, onClick }: Props) {
  const { i18n } = useI18n();

  const displayText = [query, location].filter(Boolean).join(', ');

  return (
    <QueryFieldButton
      type="button"
      aria-label={i18n('Open search')}
      data-qa-id="search-menu-button"
      onClick={onClick}
    >
      <Icon name="search" size={16} colorName="mediumContentGrey" />
      {displayText ? (
        <QueryFieldText>{displayText}</QueryFieldText>
      ) : (
        <PlaceholderText>{i18n('Search Idealist')}</PlaceholderText>
      )}
    </QueryFieldButton>
  );
}
